export default __webpack_public_path__ + "static/LogoLight-0d9c4d11b2c24f10076fd364f76db1c0.png";